<template>
  <div>
    <div v-if="posts.length > 0">
      <div class="relative font-medium text-xl mx-2 pl-2 z-10
      before:content-[''] before:bg-zt-red before:rounded-[5px] before:h-6 before:w-6 before:absolute before:left-0
      before:-z-[1] before:translate-y-[-0.1rem] xl:mx-0">
        Sprawdź też <span class="text-zt-red">inne wpisy</span>
      </div>
      <hr class="border-t-[3px] border-zt-normal rounded-full mt-3 mb-4 mx-2 xl:mx-0">
      <div class="os overflow-x-auto w-full pb-2.5 mb-2.5">
        <div class="flex flex-row w-fit px-2 gap-x-3 xl:px-0">
          <div v-for="post in posts" :key="post.id" class="!w-[147px]">
            <a :href="post.link" :title="post.title" class="no-default-style zt-hover">
              <div class="w-[147px] h-[82px] overflow-hidden rounded-[5px] relative shadow-zt
                          bg-[url(/wp-content/themes/zawodtyper/assets/images/postfallback.svg)] bg-no-repeat bg-center bg-contain">
                <img :title="post.title"
                     src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                     class="w-full h-full object-cover transition-opacity bg-no-repeat bg-center bg-cover"
                     :style="{ 'background-image': 'url('+post.thumbnail_small+')' }" alt="Okładka posta">
              </div>
              <div class="font-semibold pt-2 text-xs [-webkit-line-clamp:2] [-webkit-box-orient:vertical]
                                [display:-webkit-box] overflow-hidden">
                {{post.title}}
              </div>
            </a>
            <span class="text-xs font-light text-[#93A3BA]">{{post.date}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: 'OtherPosts',
  props: {
    data: Object,
    isBlocked: Boolean,
    isBlocking: Boolean,
    isWarned: Boolean,
    blockedUserIds: Array,
    blockingUserIds: Array,
    warnedUserIds: Array,
    isFeaturedBet: Boolean,
    isModal: Boolean,
  },
  inject: ['WP'],
  mixins: [utils_mixin],
  data() {
    return {
      posts: [],
    }
  },
  mounted() {
    this.getPosts();
  },
  updated() {
    if (this.$el.querySelector('.os')) {
      this.initializeScrollbar('.os');
    }
  },
  methods: {
    getPosts() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_posts',
          category_ids: '961',
          exclude_id: 12,
          count: 4,
          relative_date: true,
        })
        .then(response => {
          if (response.data.success) {
            this.posts = response.data.data;
          }
        });
    },
  }
}
</script>